import 'core-js/stable';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import VueResource from 'vue-resource';
import router from './router';
import AzureAD from './auth/index';
import App from './App.vue';

Vue.use(Vuetify);
Vue.use(VueResource);
Vue.use(AzureAD, {
    clientId: process.env.AZUREAD_CLIENT_ID || 'c5ed2633-24ca-4b43-8531-39b5e38d6263',
    redirectUri: process.env.AZUREAD_REDIRECT_URL || 'http://localhost:8080/signin',
    cacheLocation: 'localStorage'
});
//   instance: 'https://login.microsoftonline.com/',
//   tenant: 'dgzfp.onmicrosoft.com',
//   clientId: process.env.AZUREAD_CLIENT_ID || 'c5ed2633-24ca-4b43-8531-39b5e38d6263',
//   redirectUri: process.env.AZUREAD_REDIRECT_URL || 'http://localhost:8080/signin',
//   postLogoutRedirectUri: window.location.origin,
//   cacheLocation: 'localStorage',
//   groupFilterPrefix: 'taz-ps'
// });

Vue.http.options.root = process.env.API_ROOT || 'http://localhost:3000/api/';

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
